import {useContext, createContext, useState, useEffect} from 'react';

const AuthContext = createContext({
    isAuthenticated: false
});

export function AuthProvider({children}) {
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [user, setUser] = useState({});

    const checkAuth = async () => {
      try {
        const response = await fetch('/p_checar_sesion', {
          method: 'POST',
          credentials: 'include',
        });
        
        response.json().then((data) => {
          console.log('La data',data);
          
          if (data.status === 1) {
            if(!isAuthenticated || !user.nombre){
              console.log('La data',data);
              setUser(data.data);
              setIsAuthenticated(true);
              localStorage.setItem('isLoggedIn', 'true');
            }
          } else {
            setIsAuthenticated(false);
            localStorage.setItem('isLoggedIn', 'false');
          }
        });
      } catch (error) {
        console.error('Error al verificar autenticación:', error);
        setIsAuthenticated(false);
      }
    };

    useEffect(() => {
      checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{isAuthenticated, setIsAuthenticated, checkAuth, user}}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);